/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

import Colors from '../constants/Colors';
import { Image, Title } from './core';
import MediaQueries from '../constants/MediaQueries';

class Hero extends Component<{
  backgroundImageSrc?: any,
  backgroundImageSrc2x?: any,
  backgroundColor?: string,
  backgroundGradient?: string,
  backgroundImageStyle?: any,
  children?: any,
  style?: Object,
  className?: string,
}> {
  static defaultProps = {
    backgroundColor: Colors.IndigoDark,
    backgroundGradient:
      'linear-gradient(-180deg, rgba(40,48,96,0.30) 2%, rgba(39,47,96,0.60) 49%, #283060)',
  };

  render() {
    let {
      backgroundImageSrc,
      backgroundImageSrc2x,
      backgroundColor,
      backgroundGradient,
      backgroundImageStyle,
      children,
      style,
      className,
    } = this.props;

    return (
      <div className={names(Styles.Container, className)} style={{ backgroundColor, ...style }}>
        <div className={names(Styles.AbsoluteFill, Styles.BackgroundImageContainer)}>
          <div className={Styles.BackgroundImageWrapper}>
            <div className={Styles.AbsoluteFill} style={{ backgroundImage: backgroundGradient }} />
            {(backgroundImageSrc || backgroundImageSrc2x) && (
              <Image
                src={backgroundImageSrc}
                src2x={backgroundImageSrc2x}
                style={backgroundImageStyle}
                className={Styles.BackgroundImage}
              />
            )}
          </div>
        </div>
        <div className={Styles.Body}>{children}</div>
      </div>
    );
  }
}

export function HeroTitle({
  title,
  subtitle,
  big,
  style,
  className,
  align = 'left',
}: {
  title: string,
  subtitle?: string,
  big?: boolean,
  style?: any,
  align?: 'left' | 'right' | 'center',
}) {
  let subtitleElement;
  if (subtitle) {
    subtitleElement = (
      <Title
        color={Colors.opacity(Colors.White, 0.7)}
        size="28"
        weight="light"
        className={Styles.Subtitle}
        align={align}>
        {subtitle}
      </Title>
    );
  }

  return (
    <div className={className} style={style}>
      <Title size={big ? '80' : '56'} color={Colors.White} weight="black" align={align}>
        {title}
      </Title>
      {subtitleElement}
    </div>
  );
}

export function HeroFooter({ children }: { children?: any }) {
  return <div className={Styles.Footer}>{children}</div>;
}

const Styles = {
  Container: css`
    padding-top: 64px;
    position: relative;
    ${MediaQueries.Medium} {
      padding-top: 82px;
    }
  `,
  AbsoluteFill: css`
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  `,
  BackgroundImageContainer: css`
    overflow: hidden;
    top: 0;
  `,
  BackgroundImageWrapper: css`
    position: relative;
    text-align: center;
  `,
  BackgroundImage: css`
    width: 100%;
    margin: 0 auto;
  `,
  Body: css`
    position: relative;
  `,
  Subtitle: css`
    margin-bottom: 30px;
    margin-top: 8px;
  `,
  Footer: css`
    background-color: ${Colors.GrayLight};
    padding: 20px 0;
    ${MediaQueries.Large} {
      padding: 40px 0;
    }
  `,
};

export default Hero;



// WEBPACK FOOTER //
// ./src/ui/components/Hero.js